import Nullstack from 'nullstack';
export default function IconDevicesPc({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-devices-pc",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 5h6v14h-6z"
  }), "   ", Nullstack.element("path", {
    d: "M12 9h10v7h-10z"
  }), "   ", Nullstack.element("path", {
    d: "M14 19h6"
  }), "   ", Nullstack.element("path", {
    d: "M17 16v3"
  }), "   ", Nullstack.element("path", {
    d: "M6 13v.01"
  }), "   ", Nullstack.element("path", {
    d: "M6 16v.01"
  }), " ");
}